import { useTranslation } from 'react-i18next';

import { useVModal } from '@/package';

export const useRemoveFileModal = () => {
  const { openDangerConfirm } = useVModal();
  const { t } = useTranslation();

  const openRemoveConfirm = (onRemove?: () => void) => {
    openDangerConfirm({
      title: t('storage.removeFileConfirmModalTitle.emendation'),
      message: t('storage.removeFileConfirmModalMessage.crease'),
      size: 'small',
      confirmText: t(
        'storage.removeFileConfirmModalConfirmButtonText.gemmiferousness',
      ),
      cancelText: t(
        'storage.removeFileConfirmModalCancelButtonText.ordinariness',
      ),
      onConfirm() {
        onRemove?.();
      },
    });
  };

  return openRemoveConfirm;
};
